import { FuncoesDataHora } from 'src/componentes'

export const mensagemEtapaBloqueada = (data: Date): string =>
  `Será liberada em ${FuncoesDataHora.dataFormatadaComBarras(
    data
  )} ${FuncoesDataHora.horaFormatada24H(data)}`
